export default [
    {
        path: '/additionals/edit/:id',
        name: 'additional',
        component: () => import( /* webpackChunkName: "additional" */ '@/views/sales/Additional.vue')
    },
    {
        path: '/additionals/list',
        name: 'additionals',
        component: () => import( /* webpackChunkName: "additionals" */ '@/views/sales/Additionals.vue')
    },
    {
        path: '/averages',
        name: 'averages',
        component: () => import( /* webpackChunkName: "averages" */ '@/views/sales/Averages.vue')
    },
    {
        path: '/changePrices',
        name: 'changePrices',
        component: () => import( /* webpackChunkName: "changePrices" */ '@/views/sales/ChangePrices.vue')
    },
    {
        path: '/createFiles/:id',
        name: 'createFiles',
        component: () => import( /* webpackChunkName: "createFiles" */ '@/views/sales/createFiles/CreateFiles.vue')
    },
    {
        path: '/createFile/:id/:fileid',
        name: 'createFile',
        component: () => import( /* webpackChunkName: "createFile" */ '@/views/sales/createFiles/CreateFile.vue')
    },
    {
        path: '/createFileOld/:id',
        name: 'createFileOld',
        component: () => import( /* webpackChunkName: "createFileOld" */ '@/views/sales/CreateFileOld.vue')
    },
    {
        path: '/descriptions/add',
        name: 'descriptionAdd',
        component: () => import( /* webpackChunkName: "description" */ '@/views/sales/maintenance/Description.vue')
    },
    {
        path: '/descriptions/edit/:id',
        name: 'description',
        component: () => import( /* webpackChunkName: "description" */ '@/views/sales/maintenance/Description.vue')
    },
    {
        path: '/descriptions/list',
        name: 'descriptions',
        component: () => import( /* webpackChunkName: "descriptions" */ '@/views/sales/maintenance/Descriptions.vue')
    },
    {
        path: '/diary',
        name: 'diary',
        component: () => import( /* webpackChunkName: "diary" */ '@/views/sales/Diary.vue')
    },
    {
        path: '/emailOffers',
        name: 'emailOffers',
        component: () => import( /* webpackChunkName: "emailOffers" */ '@/views/sales/EmailOffers.vue')
    },
    {
        path: '/emailPanelsSales',
        name: 'emailPanelsSales',
        component: () => import( /* webpackChunkName: "emailPanelsSales" */ '@/views/sales/EmailPanels.vue')
    },
    {
        path: '/emailPanelsSales/add',
        name: 'emailPanelSalesAdd',
        component: () => import( /* webpackChunkName: "emailTemplateSales" */ '@/views/sales/EmailPanel.vue')
    },
    {
        path: '/emailPanelsSales/:id',
        name: 'emailPanelSales',
        component: () => import( /* webpackChunkName: "emailPanelSales" */ '@/views/sales/EmailPanel.vue')
    },
    {
        path: '/emailTemplatesSales',
        name: 'emailTemplatesSales',
        component: () => import( /* webpackChunkName: "emailTemplatesSales" */ '@/views/sales/EmailTemplates.vue')
    },
    {
        path: '/emailTemplatesSales/:id',
        name: 'emailTemplateSales',
        component: () => import( /* webpackChunkName: "emailTemplateSales" */ '@/views/sales/EmailTemplate.vue')
    },
    {
        path: '/emailTemplatesSales/:id/emailTemplatesRevisionSales/add',
        name: 'emailTemplateRevisionSalesAdd',
        component: () => import( /* webpackChunkName: "emailTemplateRevisionSales" */ '@/views/sales/EmailTemplateRevision.vue')
    },
    {
        path: '/emailTemplatesSales/:id/emailTemplatesRevisionSales/:revisionid/copy',
        name: 'emailTemplateRevisionSalesCopy',
        component: () => import( /* webpackChunkName: "emailTemplateRevisionSalesCopy" */ '@/views/sales/EmailTemplateRevisionCopy.vue')
    },
    {
        path: '/emailTemplatesSales/:id/emailTemplatesRevisionSales/:revisionid',
        name: 'emailTemplateRevisionSales',
        component: () => import( /* webpackChunkName: "emailTemplateRevisionSales" */ '@/views/sales/EmailTemplateRevision.vue')
    },
    {
        path: '/evaluateQuote/:id',
        name: 'evaluateQuote',
        component: () => import( /* webpackChunkName: "evaluateQuote" */ '@/views/sales/EvaluateQuote.vue')
    },
    {
        path: '/leadScriptApis',
        name: 'leadScriptApis',
        component: () => import( /* webpackChunkName: "leadScriptApis" */ '@/views/sales/maintenance/LeadScriptApis.vue')
    },
    {
        path: '/leadScriptApis/add',
        name: 'leadScriptApiAdd',
        component: () => import( /* webpackChunkName: "leadScriptApi" */ '@/views/sales/maintenance/LeadScriptApi.vue')
    },
    {
        path: '/leadScriptApis/edit/:id',
        name: 'leadScriptApi',
        component: () => import( /* webpackChunkName: "leadScriptApi" */ '@/views/sales/maintenance/LeadScriptApi.vue')
    },
    {
        path: '/leadScripts',
        name: 'leadScripts',
        component: () => import( /* webpackChunkName: "leadScripts" */ '@/views/sales/maintenance/LeadScripts.vue')
    },
    {
        path: '/leadScripts/add',
        name: 'leadScriptAdd',
        component: () => import( /* webpackChunkName: "leadScript" */ '@/views/sales/maintenance/LeadScript.vue')
    },
    {
        path: '/leadScripts/edit/:id',
        name: 'leadScript',
        component: () => import( /* webpackChunkName: "leadScript" */ '@/views/sales/maintenance/LeadScript.vue')
    },
    {
        path: '/promotions',
        name: 'promotions',
        component: () => import( /* webpackChunkName: "promotions" */ '@/views/sales/Promotions.vue')
    },
    {
        path: '/promotions/add',
        name: 'promotionAdd',
        component: () => import( /* webpackChunkName: "promotion" */ '@/views/sales/Promotion.vue')
    },
    {
        path: '/promotions/edit/:id',
        name: 'promotion',
        component: () => import( /* webpackChunkName: "promotion" */ '@/views/sales/Promotion.vue')
    },
    {
        path: '/questions/add',
        name: 'questionAdd',
        component: () => import( /* webpackChunkName: "question" */ '@/views/sales/maintenance/Question.vue')
    },
    {
        path: '/questions/:id',
        name: 'question',
        component: () => import( /* webpackChunkName: "question" */ '@/views/sales/maintenance/Question.vue')
    },
    {
        path: '/quoteCategories',
        name: 'quoteCategories',
        component: () => import( /* webpackChunkName: "quoteCategories" */ '@/views/sales/maintenance/Categories.vue')
    },
    {
        path: '/quoteCategories/:id',
        name: 'quoteCategory',
        component: () => import( /* webpackChunkName: "quoteCategory" */ '@/views/sales/maintenance/Category.vue')
    },
    {
        path: '/quoteActions/add',
        name: 'quoteActionAdd',
        component: () => import( /* webpackChunkName: "quoteAction" */ '@/views/sales/maintenance/Action.vue')
    },
    {
        path: '/quoteActions/:id',
        name: 'quoteAction',
        component: () => import( /* webpackChunkName: "quoteAction" */ '@/views/sales/maintenance/Action.vue')
    },
    {
        path: '/quoteConditions/add',
        name: 'quoteConditionAdd',
        component: () => import( /* webpackChunkName: "quoteCondition" */ '@/views/sales/maintenance/Condition.vue')
    },
    {
        path: '/quoteConditions/:id',
        name: 'quoteCondition',
        component: () => import( /* webpackChunkName: "quoteCondition" */ '@/views/sales/maintenance/Condition.vue')
    },
    {
        path: '/quoteRules/:id',
        name: 'quoteRule',
        component: () => import( /* webpackChunkName: "quoteRule" */ '@/views/sales/maintenance/Rule.vue')
    },
    {
        path: '/quoteRuleSets/:id',
        name: 'quoteRuleSet',
        component: () => import( /* webpackChunkName: "quoteRuleSet" */ '@/views/sales/maintenance/RuleSet.vue')
    },
    {
        path: '/quoteScripts/:id',
        name: 'quoteScript',
        component: () => import( /* webpackChunkName: "quoteScript" */ '@/views/sales/maintenance/QuoteScript.vue')
    },
    {
        path: '/quoteSections/add',
        name: 'quoteSectionAdd',
        component: () => import( /* webpackChunkName: "quoteSection" */ '@/views/sales/maintenance/Section.vue')
    },
    {
        path: '/quoteSections/:id',
        name: 'quoteSection',
        component: () => import( /* webpackChunkName: "quoteSection" */ '@/views/sales/maintenance/Section.vue')
    },
    {
        path: '/quoteEmail/:id/:emailId?',
        name: 'quoteEmail',
        component: () => import( /* webpackChunkName: "quoteEmail" */ '@/views/sales/QuoteEmail.vue')
    },
    {
        path: '/quoteNew',
        name: 'newQuote',
        component: () => import( /* webpackChunkName: "newQuote" */ '@/views/sales/NewQuote.vue')
    },
    {
        path: '/quoteParameters/add',
        name: 'quoteParameterAdd',
        component: () => import( /* webpackChunkName: "quoteParameter" */ '@/views/sales/maintenance/Parameter.vue')
    },
    {
        path: '/quoteParameters/edit/:id',
        name: 'quoteParameter',
        component: () => import( /* webpackChunkName: "quoteParameter" */ '@/views/sales/maintenance/Parameter.vue')
    },
    {
        path: '/quoteParameters',
        name: 'quoteParameters',
        component: () => import( /* webpackChunkName: "quoteParameters" */ '@/views/sales/maintenance/Parameters.vue')
    },
    {
        path: '/quoteParameterTypes/add',
        name: 'quoteParameterTypeAdd',
        component: () => import( /* webpackChunkName: "quoteParameterType" */ '@/views/sales/maintenance/ParameterType.vue')
    },
    {
        path: '/quoteParameterTypes/edit/:id',
        name: 'quoteParameterType',
        component: () => import( /* webpackChunkName: "quoteParameterType" */ '@/views/sales/maintenance/ParameterType.vue')
    },
    {
        path: '/quoteParameterTypes',
        name: 'quoteParameterTypes',
        component: () => import( /* webpackChunkName: "quoteParameterTypes" */ '@/views/sales/maintenance/ParameterTypes.vue')
    },
    {
        path: '/quote/questions/:quoteTypeId',
        name: 'quoteQuestions',
        component: () => import( /* webpackChunkName: "quoteQuestions" */ '@/views/sales/QuoteQuestions.vue')
    },
    {
        path: '/quote/search',
        name: 'quoteSearch',
        component: () => import( /* webpackChunkName: "quoteSearch" */ '@/views/sales/Search.vue')
    },
    {
        path: '/quotes/:id/scheduleEmails',
        name: 'scheduleEmails',
        component: () => import( /* webpackChunkName: "scheduleEmails" */ '@/views/sales/ScheduleEmails.vue')
    },
    {
        path: '/quotes/:id',
        name: 'quote',
        component: () => import( /* webpackChunkName: "quote" */ '@/views/sales/Quote.vue'),
    },
    {
        path: '/quoteTypes',
        name: 'quoteTypes',
        component: () => import( /* webpackChunkName: "quoteTypes" */ '@/views/sales/maintenance/QuoteTypes.vue')
    },
    {
        path: '/quoteTypes/add',
        name: 'quoteTypeAdd',
        component: () => import( /* webpackChunkName: "quoteType" */ '@/views/sales/maintenance/QuoteType.vue')
    },
    {
        path: '/quoteTypes/edit/:id',
        name: 'quoteType',
        component: () => import( /* webpackChunkName: "quoteType" */ '@/views/sales/maintenance/QuoteType.vue')
    },
    {
        path: '/referrals',
        name: 'referrals',
        component: () => import( /* webpackChunkName: "referrals" */ '@/views/sales/Referrals.vue')
    },
    {
        path: '/referrers/:id',
        name: 'referrer',
        component: () => import( /* webpackChunkName: "referrer" */ '@/views/sales/Referrer.vue')
    },
    {
        path: '/referrerMonth',
        name: 'referrerMonth',
        component: () => import( /* webpackChunkName: "referrerMonth" */ '@/views/sales/ReferrerMonth.vue')
    },
    {
        path: '/salesGroups/add',
        name: 'salesGroupAdd',
        component: () => import( /* webpackChunkName: "salesGroup" */ '@/views/sales/maintenance/Group.vue')
    },
    {
        path: '/salesGroups/edit/:id',
        name: 'salesGroup',
        component: () => import( /* webpackChunkName: "salesGroup" */ '@/views/sales/maintenance/Group.vue')
    },
    {
        path: '/salesGroups/list',
        name: 'salesGroups',
        component: () => import( /* webpackChunkName: "salesGroups" */ '@/views/sales/maintenance/Groups.vue')
    },
    {
        path: '/scaleFees/add',
        name: 'scaleFeeAdd',
        component: () => import( /* webpackChunkName: "scaleFee" */ '@/views/sales/maintenance/ScaleFee.vue')
    },
    {
        path: '/scaleFees/edit/:id',
        name: 'scaleFee',
        component: () => import( /* webpackChunkName: "scaleFee" */ '@/views/sales/maintenance/ScaleFee.vue')
    },
    {
        path: '/scaleFeeTypes/add',
        name: 'scaleFeeTypeAdd',
        component: () => import( /* webpackChunkName: "scaleFeeType" */ '@/views/sales/maintenance/ScaleFeeType.vue')
    },
    {
        path: '/scaleFeeTypes/:id',
        name: 'scaleFeeType',
        component: () => import( /* webpackChunkName: "scaleFeeType" */ '@/views/sales/maintenance/ScaleFeeType.vue')
    },
    {
        path: '/scalePercentages/add',
        name: 'scalePercentageAdd',
        component: () => import( /* webpackChunkName: "scalePercentage" */ '@/views/sales/maintenance/ScalePercentage.vue')
    },
    {
        path: '/scalePercentages/:id',
        name: 'scalePercentage',
        component: () => import( /* webpackChunkName: "scalePercentage" */ '@/views/sales/maintenance/ScalePercentage.vue')
    },
    {
        path: '/scalePercentageTypes/add',
        name: 'scalePercentageTypeAdd',
        component: () => import( /* webpackChunkName: "scalePercentageType" */ '@/views/sales/maintenance/ScalePercentageType.vue')
    },
    {
        path: '/scalePercentageTypes/:id',
        name: 'scalePercentageType',
        component: () => import( /* webpackChunkName: "scalePercentageType" */ '@/views/sales/maintenance/ScalePercentageType.vue')
    },
    {
        path: '/scales',
        name: 'scales',
        component: () => import( /* webpackChunkName: "scales" */ '@/views/sales/maintenance/Scales.vue')
    },
    {
        path: '/scaleTypes',
        name: 'scaleTypes',
        component: () => import( /* webpackChunkName: "scaleTypes" */ '@/views/sales/maintenance/ScaleTypes.vue')
    },
    {
        path: '/undealt',
        name: 'undealt',
        component: () => import( /* webpackChunkName: "undealt" */ '@/views/sales/Undealt.vue')
    },
]